<!-- Section Électrolyseur Cellule -->
<app-collapse
  [title]="'P0003607.status.electrolyseurCellule' | translate"
  [warning]="getValue('esSArretElectrolyseurProtectionHivernage') === 1"
>
  <div slot="contenu">
    <app-display-rubrique-status-with-warning
      [title]="'P0003607.status.protectionHivernage' | translate"
      [warning]="getValue('esSArretElectrolyseurProtectionHivernage') === 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'-'"
    />

    <app-display-rubrique-status
      [title]="'P0003607.status.polarite' | translate"
      [value]="
        getValue('esSArretElectrolyseurInversionPolarite') === 0
          ? '-'
          : ('P0003607.status.enCours' | translate)
      "
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P0003607.status.nbrPolarite' | translate"
        [value]="getValue('esSCompteurInversionPolarite') + ''"
      />

      <app-display-rubrique-status
        [title]="'P0003607.status.tempEau' | translate"
        [value]="
          getValue('esSTemperatureReferenceDisponibleProtectionHivernage') === 1
            ? ('P0003607.status.ok' | translate)
            : ('P0003607.status.indisponible' | translate)
        "
      />
    }

    <app-display-rubrique-status
      [title]="'P0003607.status.consommation' | translate"
      [value]="
        (getValue('esSCourantConsomme') / 10).toFixed(1) +
        ('P0003607.status.A' | translate)
      "
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P0003607.status.puissanceApparente' | translate"
        [value]="
          getValue('esSPuissanceApparente') + ('P0003607.status.VA' | translate)
        "
      />
    }

    <app-display-rubrique-status
      [title]="'P0003607.status.puissance' | translate"
      [value]="
        getValue('esSPuissanceActive') + ('P0003607.status.W' | translate)
      "
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P0003607.status.tempBasse' | translate"
        [value]="
          getValue('esSCumulTempsFonctionnementTemperatureBasse') +
          ('P0003607.status.H' | translate)
        "
      />
    }
  </div>
</app-collapse>

<!-- Section Désinfection -->
<app-collapse
  [title]="'P0003607.status.desinfection' | translate"
  [warning]="
    getValue('esSSecuriteDesinfection') === 1 ||
    getValue('esSArretElectrolyseurProtectionDebit') === 1
  "
>
  <div slot="contenu">
    <app-display-rubrique-status-with-warning
      [title]="'P0003607.status.detectionDebit' | translate"
      [warning]="getValue('esSArretElectrolyseurProtectionDebit') === 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'--'"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P0003607.status.detectionDebitReference' | translate"
        [value]="
          getValue('esSDetectionDebitReference') === 0
            ? ('P0003607.status.indisponible' | translate)
            : getValue('esSDetectionDebitReference') === 1
              ? ('P0003607.status.absent' | translate)
              : ('P0003607.status.present' | translate)
        "
      />
    }

    <app-display-rubrique-status-with-warning
      [title]="'P0003607.status.secuDesinfection' | translate"
      [warning]="getValue('esSSecuriteDesinfection') === 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'P0003607.status.ok' | translate"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P0003607.status.mesureRX' | translate"
        [value]="
          getValue('esSMesureRxReference') === 0
            ? ('P0003607.status.non' | translate)
            : ('P0003607.status.oui' | translate)
        "
      />

      <app-display-rubrique-status
        [title]="'P0003607.status.voletAlimentation' | translate"
        [value]="
          getValue('esSArretElectrolyseurAsservissementAlimentation') === 0
            ? '-'
            : ('P0003607.status.enCours' | translate)
        "
      />

      <app-display-rubrique-status
        [title]="'P0003607.status.voletSel' | translate"
        [value]="
          getValue('esSAsservissementContactSelVolet') === 0
            ? '-'
            : ('P0003607.status.enCours' | translate)
        "
      />

      <app-display-rubrique-status
        [title]="'P0003607.status.prioriteElectrolyse' | translate"
        [value]="
          getValue('esSMiseRouteFiltrationPrioElectrolyse') === 0
            ? '-'
            : ('P0003607.status.enCours' | translate)
        "
      />

      <app-display-rubrique-status
        [title]="'P0003607.status.autoFiltration' | translate"
        [value]="
          getValue('esSMiseRouteFiltrationPrioAutoMaintien') === 0
            ? '-'
            : ('P0003607.status.enCours' | translate)
        "
      />
    }
  </div>
</app-collapse>

<!-- Section Produit -->
<app-collapse
  [title]="'P0003607.status.produit' | translate"
  [warning]="presenceProduit === 2"
>
  <div slot="contenu">
    <app-display-rubrique-status-with-warning
      [title]="'P0003607.status.connexionCoffret' | translate"
      [warning]="presenceProduit === 2"
      [icon]="'fa-exclamation-triangle'"
      [text]="'P0003607.status.ok' | translate"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P0003607.status.puissanceTotale' | translate"
        [value]="getValue('esSCompteurPuissanceActiveTotal') + ' Wh'"
      />

      <app-display-rubrique-status
        [title]="'P0003607.status.compteurAmpere' | translate"
        [value]="
          getValue('esSCompteurAmpereHeure') +
          ('P0003607.status.Ah' | translate)
        "
      />

      <app-display-rubrique-status
        [title]="'P0003607.status.nbrCommutationRelais' | translate"
        [value]="getValue('esSNombreCommutationRelais') + ''"
      />
    }

    <app-display-rubrique-status
      [title]="'P0003607.status.tenionSecteur' | translate"
      [value]="
        getValue('esSTensionSecteur') + ('P0003607.status.V' | translate)
      "
    />

    <app-display-rubrique-status
      [title]="'P0003607.status.tempsTension' | translate"
      [value]="transformHourToDayHourLocal(getValue('esSTempsSousTension'))"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status-on-off
        [title]="'P0003607.status.bouton' | translate"
        [value]="getValue('esSEtatBouton') !== 0"
      />

      <app-display-rubrique-status
        [title]="'P0003607.status.cptBouton' | translate"
        [value]="getValue('esSCompteurBouton') + ''"
      />

      <app-display-rubrique-status-on-off
        [title]="'P0003607.status.fctElectrolyseur' | translate"
        [value]="getValue('esSEtatSortieElectrolyseur') !== 0"
      />
    }
  </div>
</app-collapse>
